module.exports = __webpack_public_path__ + "img/map.171985ed.jpg";